/* @ngInject */
function AuditListController ($scope, $rootScope, $state, $stateParams, $timeout, $q, $location, $translate, $controller, $window, AuditService, AdminService, ModalService, ToastService, SegmentService, Utils, UdsModalService) {
  const getAuditDetailDialogController = () => $q.when(import('../../dialogs/audit-detail/audit-detail-dialog.controller'))
  const getNewAuditDialogController = () => $q.when(import('../../dialogs/new-audit/new-audit-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => $q.when(import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller'))

  const AUDIT_SCORE_COUNT = 10

  $scope.flags = {
    loading: true
  }
  $scope.audits = []
  $scope.auditsCount = 0
  $scope.paginationTop = 15
  $scope.tokensCount = $rootScope.isDesktop ? 10 : 5
  $scope.skipPagingTo = skipPagingTo
  $scope.dropdownOptions = ['ASC', 'DESC']
  $scope.auditModels = []
  $scope.users = []
  $scope.filters = {}
  $scope.notHasChecklistAccess = false

  let advancedFilters = null

  $scope.optionSelected = {}

  const api = {
    getAuditDetailDialogController,
    getNewAuditDialogController,
    getUpgradeCompanyPlanDialogController,
    skipPagingTo,
    _setUrlParams,
    _setOptionSelected,
    _openAuditDetailDialog,
    _successGetAudits,
    _handleSuccessGetTemplates,
    _handleSuccessGetUsers,
    _handleSuccessGetStatus,
    _errorGetAudits,
    _handleNewAuditClick,
    _handleOpenBriefingModels,
    _getHeaderRightButtons,
    _onSearch,
    _onFilter,
    _initHeader,
    _openUpgradeCompanyPlanDialog
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._initHeader()
    api._setOptionSelected()
    if ($stateParams.audit) {
      api._openAuditDetailDialog($stateParams.audit)
    }

    AuditService.getAuditTemplates().then(api._handleSuccessGetTemplates)
    AuditService.getAuditStatus().then(api._handleSuccessGetStatus)

    if ($rootScope.isUserSysAdminAdminDesigner()) {
      AdminService.getUsersSimplified({ active: true }).then(api._handleSuccessGetUsers)
    }

    const urlFilters = $location.search()
    const lastUserFilters = JSON.parse($window.sessionStorage.getItem('auditFilters'))

    if (Object.keys(urlFilters).length) {
      $scope.filters = {
        ...urlFilters,
        dateMoment: urlFilters.dateMoment && moment(urlFilters.dateMoment)
      }
    } else if (lastUserFilters) {
      $scope.filters = {
        ...lastUserFilters,
        dateMoment: lastUserFilters.dateMoment && moment(lastUserFilters.dateMoment)
      }
    } else {
      api.skipPagingTo(0)
    }

    $timeout(() => {
      $('.audit-order-dropdown').dropdown({
        keepOnScreen: false
      })
    }, 0, false)
  }

  const deregisterReloadAudits = $scope.$on('reloadAudits', api.skipPagingTo)

  $scope.$on('$destroy', () => {
    deregisterReloadAudits()
  })

  $scope.$watchCollection('filters', function (newVal) {
    if (newVal.dateMoment && typeof newVal.dateMoment === 'object') {
      $scope.filters.date = newVal.dateMoment.format('YYYY-MM-DD')
    }
    api._setUrlParams()
  })

  $scope.clearFilters = function () {
    $scope.filters = {}
    api._setUrlParams()
    api.skipPagingTo(0)
  }

  function _handleNewAuditClick (event) {
    const pricing = event?.detail?.pricing

    if (pricing) {
      return api._openUpgradeCompanyPlanDialog({
        featureName: $translate.instant('generalSettings.CHECKLIST.ACCESS'),
        featureSlug: 'CHECKLIST.ACCESS'
      })
    }

    api.getNewAuditDialogController().then(({ NewAuditDialogController }) => {
      ModalService.showModal({
        templateId: 'newAudit.html',
        templateUrl: '/audit/dialogs/new-audit/new-audit-dialog.html?$$REVISION$$',
        controller: NewAuditDialogController,
        destroyable: true,
        observeChanges: true
      })
        .then(reload => {
          if (reload) {
            api.skipPagingTo(0)
          }
        })
    })
  }

  $scope.handleNewAuditClick = api._handleNewAuditClick

  $scope.goToAuditModels = () => {
    $state.go('audit.models')
  }

  function _handleOpenBriefingModels (event) {
    const pricing = event?.detail?.pricing

    if (pricing) {
      return api._openUpgradeCompanyPlanDialog({
        featureName: $translate.instant('generalSettings.CHECKLIST.ACCESS'),
        featureSlug: 'CHECKLIST.ACCESS'
      })
    }

    SegmentService.track('checklist-models-click')
    $state.go('audit.models')
  }

  $scope.handleOpenBriefingModels = api._handleOpenBriefingModels

  $scope.handleSelectOrder = function (title, option) {
    $scope.appliedOrder = {}
    $scope.optionSelected = title && option ? { title, option } : {}
    switch (title) {
      case 'audit':
        $scope.appliedOrder = { auditOrder: option }
        api._setUrlParams()
        break
      case 'audited':
        $scope.appliedOrder = { auditedOrder: option }
        api._setUrlParams()
        break
      case 'auditor':
        $scope.appliedOrder = { auditorOrder: option }
        api._setUrlParams()
        break
      case 'date':
        $scope.appliedOrder = { dateOrder: option }
        api._setUrlParams()
        break
      case 'score':
        $scope.appliedOrder = { scoreOrder: option }
        api._setUrlParams()
        break
      case 'status':
        $scope.appliedOrder = { statusOrder: option }
        api._setUrlParams()
        break
      default:
        api._setUrlParams()
    }
  }

  function _setUrlParams (key, value) {
    let searchOptions = {}
    if (key && value) {
      searchOptions = {
        [key]: value
      }
    }
    searchOptions = Object.assign({}, $scope.appliedOrder, $scope.filters, searchOptions)
    $location.search(searchOptions)

    $window.sessionStorage.setItem('auditFilters', JSON.stringify($scope.filters))

    api.skipPagingTo()
  }

  function _setOptionSelected () {
    const params = $location.search()
    if (params.auditOrder) {
      $scope.optionSelected = { title: 'audit', option: params.auditOrder }
    } else if (params.auditedOrder) {
      $scope.optionSelected = { title: 'audited', option: params.auditedOrder }
    } else if (params.auditorOrder) {
      $scope.optionSelected = { title: 'auditor', option: params.auditorOrder }
    } else if (params.dateOrder) {
      $scope.optionSelected = { title: 'date', option: params.dateOrder }
    } else if (params.scoreOrder) {
      $scope.optionSelected = { title: 'score', option: params.scoreOrder }
    } else if (params.statusOrder) {
      $scope.optionSelected = { title: 'status', option: params.statusOrder }
    }
  }

  function _openAuditDetailDialog (id) {
    api.getAuditDetailDialogController().then(({ AuditDetailDialogController }) => {
      ModalService.showModal({
        controller: AuditDetailDialogController,
        templateId: 'auditDetail.html',
        templateUrl: '/audit/dialogs/audit-detail/audit-detail-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        data: {
          id: id
        }
      })
    })
  }

  function skipPagingTo (token) {
    $scope.flags.loading = true
    AuditService.getAudits(
      $scope.paginationTop,
      $scope.paginationTop * token || 0,
      {
        ...$location.search(),
        ...(advancedFilters || {})
      }
    )
      .then(api._successGetAudits)
      .catch(api._errorGetAudits)
  }

  function _handleSuccessGetTemplates (response) {
    const templates = response?.rows || []

    $scope.auditModels = templates.map(template => {
      return { label: template.name, value: template.id }
    })
  }

  function _handleSuccessGetUsers (users) {
    $scope.users = users.rows.map(user => {
      return { label: user.name, value: user.id }
    })
  }

  function _handleSuccessGetStatus (status) {
    $scope.status = status.map(statusItem => {
      return { label: $translate.instant(statusItem), value: statusItem }
    })
  }

  function _successGetAudits (res) {
    $scope.audits = res.rows
    $scope.auditsCount = res.count
    $scope.flags.loading = false
  }

  function _errorGetAudits () {
    $scope.flags.loading = false
    ToastService.defaultErrorToast()
  }

  function _getHeaderRightButtons () {
    const isAdminOrDesigner = $rootScope.isUserSysAdminAdmin()

    const buttonsForAdminOrDesigner = [{
      type: 'analytics',
      module: 'checklists'
    }, {
      type: 'button',
      btnType: 'secondary',
      label: $translate.instant('models'),
      icon: 'clipboard',
      onClick: api._handleOpenBriefingModels,
      pricing: {
        prop: $scope.notHasChecklistAccess,
        tooltip: $translate.instant('modulesPricing.checklist.tooltip'),
        position: 'left'
      }
    }, {
      type: 'button',
      btnType: 'primary',
      label: $translate.instant('add'),
      icon: 'plus',
      onClick: api._handleNewAuditClick,
      pricing: {
        prop: $scope.notHasChecklistAccess,
        tooltip: $translate.instant('modulesPricing.checklist.tooltip'),
        position: 'left'
      }
    }]

    if (isAdminOrDesigner) { return buttonsForAdminOrDesigner }
    return []
  }

  function _onSearch (search) {
    if (search === '') {
      return api.skipPagingTo(0)
    }

    AuditService.getAudits($scope.auditsCount, 0, { search })
      .then(api._successGetAudits)
      .catch(api._errorGetAudits)
  }

  function _onFilter (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    advancedFilters = filters
    api.skipPagingTo(0)
  }

  function _initHeader () {
    const promises = [
      $rootScope.getUser(),
      $rootScope.getCompanyFeaturesAndAddons()
    ]

    $q.all(promises).then(([user, companyFeatures]) => {
      const checklistAccess = !!companyFeatures?.features['CHECKLIST.ACCESS']
      $scope.notHasChecklistAccess = !checklistAccess

      const filters = []
      const exhibitDefaultValue = {
        label: $translate.instant('actives'),
        value: false,
        icon: 'success',
        active: true,
        disabled: false
      }

      $scope.pageTitle = $translate.instant('Checklists')

      if ($rootScope.isUserSysAdminAdmin()) {
        filters.push({
          name: 'isArchived',
          type: 'FILTER_BUTTON_SELECT',
          grouped: false,
          defaultValue: exhibitDefaultValue,
          props: {
            label: $translate.instant('exhibit'),
            multiple: false,
            switchMode: true,
            udsDisabled: false,
            options: [
              exhibitDefaultValue,
              {
                label: $translate.instant('archivedPlural'),
                value: true,
                icon: 'archive',
                active: false,
                disabled: false
              }
            ]
          }
        })
      }

      filters.push({
        name: 'status',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('status'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('auditStatusBadge.SCHEDULED'),
              value: 'SCHEDULED',
              icon: 'calendar',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('auditStatusBadge.ANALYZE'),
              value: 'ANALYZE',
              icon: 'clock',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('auditStatusBadge.ACTION'),
              value: 'ACTION',
              icon: 'select-all',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('auditStatusBadge.FINISHED'),
              value: 'FINISHED',
              icon: 'check',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('auditStatusBadge.EXPIRED'),
              value: 'EXPIRED',
              icon: 'close',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('according'),
              value: 'EVALUATED',
              icon: 'conforming-form',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('auditStatusBadge.NONCONFORM'),
              value: 'NONCONFORM',
              icon: 'nonconforming-form',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'briefingId',
        type: 'INPUT_MULTISELECT',
        grouped: true,
        defaultValue: [],
        props: {
          label: $translate.instant('auditBriefing.auditModel'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'tag',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => AuditService.getAuditTemplates(top, skip, search)
      },
      {
        name: 'score',
        type: 'SELECT',
        grouped: true,
        defaultValue: [],
        props: {
          label: $translate.instant('score'),
          placeholder: $translate.instant('selectPlaceholder'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          options: Utils.createScoreArray(AUDIT_SCORE_COUNT)
        }
      })

      if ($rootScope.isUserSysAdminAdmin()) {
        filters.push({
          name: 'auditorId',
          type: 'INPUT_MULTISELECT',
          grouped: true,
          defaultValue: [],
          props: {
            label: $translate.instant('auditor'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            type: 'user',
            hasMoreOptions: false,
            udsDisabled: false,
            options: []
          },
          loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
        },
        {
          name: 'auditedId',
          type: 'INPUT_MULTISELECT',
          grouped: true,
          defaultValue: [],
          props: {
            label: $translate.instant('audited'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            type: 'user',
            hasMoreOptions: false,
            udsDisabled: false,
            options: []
          },
          loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
        })
      }

      filters.push({
        name: 'createdAt',
        type: 'DATE_PICKER',
        grouped: true,
        defaultValue: '',
        props: {
          locale: $rootScope.oUser.locale,
          label: $translate.instant('creationDate'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      },
      {
        name: 'date',
        type: 'DATE_PICKER',
        grouped: true,
        defaultValue: '',
        props: {
          locale: $rootScope.oUser.locale,
          label: $translate.instant('expiration'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      })

      $scope.headerToolbar = {
        rightButtons: api._getHeaderRightButtons(),
        search: {
          filters,
          onFilter: api._onFilter,
          onSearch: api._onSearch
        }
      }
    })
  }

  function _openUpgradeCompanyPlanDialog (modalData) {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: modalData
      })

      upgradeCompanyPlanDialog.open()
    })
  }
}

export { AuditListController }
